 import React , {useState,useEffect} from "react";
import { requestForToken, onMessageListener } from "./firebase";

import NavBar from "./components/NavBar";
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Homework from './pages/Homework';
import Alert from './pages/Alert';
import Library from './pages/Library';
import Quiz from "./pages/Quiz";
import SideBar from "./components/SideBar";
import Login from "./pages/Login";
import StudentLayout from './pages/StudentLayout'
import StaffLayout from './pages/StaffLayout'


import './App.css';
import AttendanceCalendar from "./components/AttendanceCalendar";
import Account from "./pages/Account";
import Profile from "./pages/Profile";
import AssignmentDetails from "./pages/AssignmentDetails";
import MCQTests from "./pages/MCQTests";
import MCQTestDetails from "./pages/MCQTestDetails";
import ViewResponse from "./pages/ViewResponse";
import TakeTest from "./pages/TakeTest";
import ClassTests from "./pages/ClassTests";
import SchoolFee from "./pages/SchoolFee";
import FeeReceipt from "./pages/FeeReceipt";
import Result from "./pages/Result";
import ResultDetails from "./pages/ResultDetails";
import Applications from "./pages/Applications";
import { Toaster } from "react-hot-toast";
import StaffDashboard from "./pages/staff/StaffDashboard";
import StaffAccount from "./pages/staff/StaffAccount";
import StaffProfile from "./pages/staff/StaffProfile";
import StaffAlert from "./pages/staff/StaffAlert";
import WebView from "./pages/staff/WebView";
import WebViewStudent from "./pages/WebView";
import StaffStudentList from "./pages/staff/StaffStudentList";
import StaffAttendanceCalendar from "./components/staff/StaffAttendanceCalendar";
import InstallButton from "./InstallButton";
const App = ()=> {
      const [show_sidebar,setSideBar] = useState(false)
  const [show_settingdrawer,setSettingDrawer] = useState(false);
      const [open_attendance, setOpen_attendance] =  useState(false);


  const [notification, setNotification] = useState({ title: "", body: "" });

 
    useEffect(() => {
    // 1. Request user permission to display alerts and extract registration token
    requestForToken();
 
    // 2. Continually listen for active foreground data events
    const unsubscribe = onMessageListener((payload) => {
      setNotification({
        title: payload?.notification?.title ?? "",
        body: payload?.notification?.body ?? "",
      });
      console.log("Foreground Notification Received:", payload);
    });

    return unsubscribe;
  }, []);


useEffect(() => {
  const isInWebView = typeof window.ReactNativeWebView !== 'undefined';

  if (isInWebView) {
    // Setup the token receiver
    window.receiveFCMToken = function ({ token, appName }) {
  localStorage.setItem('fcm_token', token);
localStorage.setItem('app_name', appName);
const toekkn = localStorage.getItem('fcm_token');;
// alert(toekkn);
    };

    // Let RN know we are ready
    window.ReactNativeWebView.postMessage('READY_FOR_TOKEN');
  }
}, []);


  return (
    <Router>
      <Toaster/>
      <InstallButton />

      <Routes>
        <Route path="/" element={<Login  setSideBar={setSideBar} />} />
        <Route path="/student" element={<StudentLayout show_settingdrawer={show_settingdrawer}  setSettingDrawer={setSettingDrawer}  show_sidebar={show_sidebar} setSideBar={setSideBar}/>}>
          <Route path="dashboard" element={<Home open_attendance={open_attendance} setOpen_attendance={setOpen_attendance} setSideBar={setSideBar} setSettingDrawer={setSettingDrawer}/>} />
         <Route path="alert" element={<Alert />} />
        <Route path="library" element={<Library />} />
        {/* <Route path="quiz" element={<Quiz />} /> */}
        <Route path="attendance" element={<AttendanceCalendar />} />
        <Route path="account" element={<Account />} />
        <Route path="profile" element={<Profile />} />
        <Route path="homework" element={<Homework setSideBar={setSideBar} setSettingDrawer={setSettingDrawer} />} />
        <Route path="homework/:id" element={<AssignmentDetails setSideBar={setSideBar} setSettingDrawer={setSettingDrawer} />} />
        <Route path="quiz" element={<MCQTests setSideBar={setSideBar} setSettingDrawer={setSettingDrawer} />} />
        <Route path="mcq-test/:id" element={<MCQTestDetails setSideBar={setSideBar} setSettingDrawer={setSettingDrawer} />} />
      <Route path="mcq-test/:id/response" element={<ViewResponse setSideBar={setSideBar} setSettingDrawer={setSettingDrawer} />} />
        <Route path="mcq-test/:id/take" element={<TakeTest setSideBar={setSideBar} setSettingDrawer={setSettingDrawer} />} />
        <Route path="class-test" element={<WebViewStudent url="classtest?view" title="Class Test"  setSideBar={setSideBar} setSettingDrawer={setSettingDrawer}/>} />
        <Route path="house-club-activity" element={<WebViewStudent url="house_club?v" title="House/Club Activity"  setSideBar={setSideBar} setSettingDrawer={setSettingDrawer}/>} />

        {/* <Route path="class-test" element={<ClassTests setSideBar={setSideBar} setSettingDrawer={setSettingDrawer} />} /> */}
        <Route path="fee" element={<SchoolFee setSideBar={setSideBar} setSettingDrawer={setSettingDrawer} />} />
        <Route path="fee-receipt/:month/:year" element={<FeeReceipt />} />
        <Route path="result" element={<Result />} />
    <Route path="result-details/:examId" element={<ResultDetails />} />
               <Route path="applications" element={<Applications/>} />

        </Route>
      
        <Route path="/staff" element={<StaffLayout show_settingdrawer={show_settingdrawer}  setSettingDrawer={setSettingDrawer}  show_sidebar={show_sidebar} setSideBar={setSideBar}/>}>

        <Route path="dashboard" element={<StaffDashboard open_attendance={open_attendance} setOpen_attendance={setOpen_attendance}  setSideBar={setSideBar} setSettingDrawer={setSettingDrawer}/>} />
        <Route path="account" element={<StaffAccount   setSideBar={setSideBar} setSettingDrawer={setSettingDrawer}/>} />
        <Route path="profile" element={<StaffProfile   setSideBar={setSideBar} setSettingDrawer={setSettingDrawer}/>} />
        <Route path="alert" element={<StaffAlert   setSideBar={setSideBar} setSettingDrawer={setSettingDrawer}/>} />
        <Route path="homework" element={<WebView url="homework?view" title="Assignments"  setSideBar={setSideBar} setSettingDrawer={setSettingDrawer}/>} />
        <Route path="ai_question_paper" element={<WebView url="generate_qp?view" title="AI Question Papers"  setSideBar={setSideBar} setSettingDrawer={setSettingDrawer}/>} />
        <Route path="quiz" element={<WebView url="mcq?view" title="MCQs"  setSideBar={setSideBar} setSettingDrawer={setSettingDrawer}/>} />
        <Route path="class-test" element={<WebView url="classtests?view" title="Class Tests"  setSideBar={setSideBar} setSettingDrawer={setSettingDrawer}/>} />
        <Route path="attendance" element={<WebView url="attendance?viewattendance" title="Attendance"  setSideBar={setSideBar} setSettingDrawer={setSettingDrawer}/>} />
        <Route path="attendance_teacher" element={<StaffAttendanceCalendar  setSideBar={setSideBar} setSettingDrawer={setSettingDrawer}/>} />
        <Route path="my_salary" element={<WebView url="my_salary?view" title="My Salary"  setSideBar={setSideBar} setSettingDrawer={setSettingDrawer}/>} />
        <Route path="manage_exam" element={<WebView url="manage_exam?view" title="Manage Exam"  setSideBar={setSideBar} setSettingDrawer={setSettingDrawer}/>} />
        <Route path="student-list/:classid/:section" element={<StaffStudentList  setSideBar={setSideBar} setSettingDrawer={setSettingDrawer}/>} />
        <Route path="diary" element={<WebView url="teacher_diary?view" title="Daily Diary"  setSideBar={setSideBar} setSettingDrawer={setSettingDrawer}/>} />
        <Route path="house-club-activity" element={<WebView url="house-club-activity?view" title="House/Club Activity"  setSideBar={setSideBar} setSettingDrawer={setSettingDrawer}/>} />


 

        </Route>
      </Routes>


    </Router>
  
  );
}

export default App;
